<template>
  <div class="p-grid" v-if="$ability.can('write', 'Owner')">
    <div class="p-col-12 p-lg-4">
      <AppSkeletonCardForm v-show="loading" :rows="10" />
      <Card v-show="!loading">
        <template v-slot:title>Dados do Proprietário</template>
        <template v-slot:content>
          <OwnerForm
            ref="ownerForm"
            :id="Number($route.params.id)"
            @saved="$router.push({ name: 'owner.list' })"
            v-model:loading="loading"
            v-model:loadingSave="loadingSave"
          ></OwnerForm>
        </template>
        <template v-slot:footer>
          <div class="p-grid p-jc-end">
            <div style="padding-right: 8px">
              <router-link tag="span" :to="{ name: 'owner.list' }">
                <Button label="Cancelar" class="p-button-outlined p-mr-2" />
              </router-link>
              <AppButton
                label="Salvar"
                @click="$refs.ownerForm.save()"
                :loading="loadingSave"
              />
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div
      class="p-col-12 p-lg-8"
      v-if="$route.params.id && $ability.can('read', 'Bovine')"
    >
      <OwnerBovineCard :id="Number($route.params.id)" />
    </div>
    <div class="p-col-12" v-if="$route.params.id">
      <div class="p-grid p-jc-end p-mt-2">
        <router-link tag="span" :to="{ name: 'owner.list' }">
          <Button label="Voltar" class="p-button-outlined p-mr-2" />
        </router-link>
      </div>
    </div>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import OwnerBovineCard from './components/OwnerBovineCard';
import OwnerForm from './components/OwnerForm';

export default {
  name: 'OwnerEdit',
  components: {
    OwnerForm,
    OwnerBovineCard,
  },
  data() {
    return {
      loading: false,
      loadingSave: false,
    };
  },
};
</script>

<style>
</style>